import React from 'react';
import Alert from 'react-bootstrap/Alert';
import Form from 'react-bootstrap/Form';

import SubmitButton from '../Forms/SubmitButton/index.jsx';

import FormField from './form-field.jsx';


class ChangePassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: undefined,
      success: undefined,
      loading: false,
      validated: false,
      confirmPassword: '',
      currentPassword: '',
      newPassword: '',
      confirmPasswordValidation: '',
      currentPasswordValidation: '',
      newPasswordValidation: ''
    };

    this.newPassword = React.createRef();

    this.onError = this.onError.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
    this.onConfirmPasswordChange = this.onConfirmPasswordChange.bind(this);
    this.onCurrentPasswordChange = this.onCurrentPasswordChange.bind(this);
    this.onNewPasswordChange = this.onNewPasswordChange.bind(this);
  }

  onConfirmPasswordChange(event) {
    this.setState({
      confirmPassword: event.target.value,
      confirmPasswordValidation: this.validateConfirmPassword(event.target)
    });
  }

  onCurrentPasswordChange(event) {
    this.setState({
      currentPassword: event.target.value,
      currentPasswordValidation: this.validateCurrentPassword(event.target)
    });
  }

  onNewPasswordChange(event) {
    this.setState({
      newPassword: event.target.value,
      newPasswordValidation: this.validateNewPassword(event.target)
    });
  }

  validateConfirmPassword(input) {
    var result;
    if (! input.checkValidity()) {
      result = input.validationMessage;
    } else {
      if (input.value != this.newPassword.current.value) {
        result = 'The new passwords must match';
      }
    }

    return result;
  }

  validateCurrentPassword(input) {
    var error;
    if (! input.checkValidity()) {
      error = input.validationMessage;
    }

    return error;
  }

  validateNewPassword(input) {
    var error;
    if (! input.checkValidity()) {
      error = input.validationMessage;
    }

    return error;
  }

  onError(error) {
    this.setState({ loading: false, error: error.message });
  }

  onSuccess() {
    // reset the form
    this.setState({
      loading: false,
      success: 'Your password has been changed',
      validated: false,
      confirmPassword: '',
      currentPassword: '',
      newPassword: ''
    });
  }

  onSubmit(event) {
    event.preventDefault();

    var newState = { validated: true, error: undefined, success: undefined };
    var form = event.currentTarget;
    var formData = {};

    // validate the form.
    var submitForm = true;
    var currentPassword = form.elements['current-password'];
    formData.currentPassword = currentPassword.value;
    newState.currentPasswordValidation = this.validateCurrentPassword(currentPassword);
    if (newState.currentPasswordValidation) {
      submitForm = false;
    }
    var newPassword = form.elements['new-password'];
    formData.newPassword = newPassword.value;
    newState.newPasswordValidation = this.validateNewPassword(newPassword);
    if (newState.newPasswordValidation) {
      submitForm = false;
    }
    var confirmPassword = form.elements['confirm-password'];
    formData.confirmPassword = confirmPassword.value;
    newState.confirmPasswordValidation = this.validateConfirmPassword(confirmPassword);
    if (newState.confirmPasswordValidation) {
      submitForm = false;
    }


    if (submitForm) {
      newState.loading = true;

      if (this.props.onSubmit) {
        this.props.onSubmit(formData)
          .then(this.onSuccess)
          .catch(this.onError);
      }
    }

    this.setState(newState);
  }

  render() {
    var error;
    var success;

    if (this.state.success) {
      success = (
        <Alert variant="success">
          <Alert.Heading>Success:</Alert.Heading>
          {this.state.success}
        </Alert>
      );
    }
    if (this.state.error) {
      error = (
        <Alert variant="danger">
          <Alert.Heading>Error:</Alert.Heading>
          {this.state.error}
        </Alert>
      );
    }


    return (
      <React.Fragment>
        <h3>Password Change</h3>
        <div className="cs-block-form">
          {success}
          {error}
          <Form noValidate onSubmit={this.onSubmit}>
            <FormField 
              id="current-password"
              name="current-password"
              type="password"
              required
              value={this.state.currentPassword}
              onChange={this.onCurrentPasswordChange}
              validated={this.state.validated}
              validationMessage={this.state.currentPasswordValidation}
              label="Current Password"
            />
            <FormField 
              id="new-password"
              name="new-password"
              type="password"
              required
              value={this.state.newPassword}
              onChange={this.onNewPasswordChange}
              validated={this.state.validated}
              validationMessage={this.state.newPasswordValidation}
              inputRef={this.newPassword}
              label="New Password"
            />
            <FormField 
              id="confirm-password"
              name="confirm-password"
              type="password"
              required
              value={this.state.confirmPassword}
              onChange={this.onConfirmPasswordChange}
              validated={this.state.validated}
              validationMessage={this.state.confirmPasswordValidation}
              label="Confirm Password"
            />
            <SubmitButton loading={this.state.loading}>
              Change Password
            </SubmitButton>
          </Form>
        </div>
      </React.Fragment>
    );
  }
}


export default ChangePassword;

